/* tslint:disable */

declare var Object: any;
export interface LogInterface {
  "type": string;
  "date": Date;
  "additionalInfo"?: any;
  "id"?: any;
}

export class Log implements LogInterface {
  "type": string;
  "date": Date;
  "additionalInfo": any;
  "id": any;
  constructor(data?: LogInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Log`.
   */
  public static getModelName() {
    return "Log";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Log for dynamic purposes.
  **/
  public static factory(data: LogInterface): Log{
    return new Log(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Log',
      plural: 'Logs',
      path: 'Logs',
      idName: 'id',
      properties: {
        "type": {
          name: 'type',
          type: 'string'
        },
        "date": {
          name: 'date',
          type: 'Date'
        },
        "additionalInfo": {
          name: 'additionalInfo',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}
